export const infogerances = [
  {
    key: 'infogerance-audit',
    title: 'Audit',
    text: 'Nous analysons vos usages IA existants, vos risques et vos besoins métier.',
    iconFamily: 'fa-solid',
    icon: 'magnifying-glass-chart',
  },
  {
    key: 'infogerance-recommandation',
    title: 'Recommandation',
    text: 'Nous proposons les cas d’usage prioritaires et l’architecture adaptée, sûre et évolutive.',
    iconFamily: 'fa-solid',
    icon: 'clipboard',
  },
  {
    key: 'infogerance-mise-en-oeuvre',
    title: 'Mise en œuvre',
    text: 'Déploiement de votre IA souveraine, intégration et reprise des données dans des conditions maîtrisées.',
    iconFamily: 'fa-solid',
    icon: 'rocket',
  },
  {
    key: 'infogerance-supervision-continue',
    title: 'Supervision continue',
    text: 'Vérification à la minute, alertes SMS, email et messagerie instantanée.',
    iconFamily: 'fa-solid',
    icon: 'satellite',
  },
  {
    key: 'infogerance-evolution',
    title: 'Évolution',
    text: 'Nouveaux modèles, nouvelles fonctions, montée en charge de vos usages : votre IA évolue avec vous.',
    iconFamily: 'fa-solid',
    icon: 'chart-line',
  },
]
